module.controller('directDepositCtrl', ['$scope', '$state', '$http', '$rootScope', '$window', 'Session', 'baseURI', 'Transform', '$stateParams', 'brandService', 'OVERLAY',
  function ($scope, $state, $http, $rootScope, $window, Session, baseURI, Transform, $stateParams, brandService, OVERLAY){
    var url = baseURI + 'directdeposit';
    $scope.overlay = OVERLAY['member.home.directdeposit'];
    $scope.formData = {};
    var printViewParams = {};

    if (!$stateParams.brand) {
      $scope.brand = brandService.getBrand(Session.getBrand());
    } else {
      $scope.brand = brandService.getBrand($stateParams.brand);
    }

    $scope.printDirectDeposit = function(){
      var printViewUrl = $state.href('printDirectDeposit');
      printViewUrl = printViewUrl + '?' + Transform.encode(printViewParams);
      window.open(printViewUrl, '_blank');
    };

    printViewParams.Bank = $scope.brand.issuer.bank;
    printViewParams.Routing = $scope.Routing;
    printViewParams.AccountNumber = $scope.AccountNumber;


    $scope.closeOrRedirect = function(){
      $rootScope.back();
    };

    $http.get(url).then(function (resp){
      var data = resp.data;

      $scope.AccountNumber = data.Data.Account;
      $scope.Routing = data.Data.Routing;
    }).catch(function (error){
      console.log('err', error);
    });
  }]);
